import React from "react";
import { Button } from "antd";

// Components
import SupportProfile from "./components/SupportProfile";
import SupportLayout from "./SupportLayout";

// Custom hook
import useSupportData from "./hooks/useSupportData";

const SupportProfilePage = () => {
  const { supportProfile, loading, updateSupportProfile } = useSupportData();

  return (
    <SupportLayout>
      <div className="pb-40">
        <div className="main_container_title_div mb-5 mt-10 flex items-center justify-between">
          <h5 className="!mt-0">My Support Profile</h5>
          <Button
            type="primary"
            onClick={() => console.log("Edit profile")}
            className="bg-black hover:bg-gray-800"
            style={{ backgroundColor: "#000000", borderColor: "#000000" }}
          >
            Edit My Profile
          </Button>
        </div>
        <SupportProfile
          supportProfile={supportProfile}
          onUpdateProfile={updateSupportProfile}
          loading={loading}
        />
      </div>
    </SupportLayout>
  );
};

export default SupportProfilePage;
